import { ModuleWithProviders }  from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../core';
import { LoginScreenComponent } from './login-screen/login-screen.component';
import { ChangePasswordComponent } from './change-password/change-password.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginScreenComponent
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
    canActivate: [AuthGuard]
  }
];

export const LoginRoutes: ModuleWithProviders = RouterModule.forChild(routes);


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/login/login.routes.ts